"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserApiErrorType = void 0;
var UserApiErrorType;
(function (UserApiErrorType) {
    UserApiErrorType["PARTNER_OR_MEMBERSHIP_NOT_FOUND"] = "universcoop.users.partnerOrMembershipNotFound";
    UserApiErrorType["AUTH0_USER_NOT_FOUND"] = "universcoop.users.auth0UserNotFound";
})(UserApiErrorType || (exports.UserApiErrorType = UserApiErrorType = {}));
